import axios from "axios";

// Instance dédiée à l'espace famille : elle ne doit JAMAIS porter le jeton de la console
// (celui de `lib/data.js`), sinon un parent enverrait un en-tête d'administrateur.
// Le cookie de session suffit sur le web ; le jeton en réserve sert à l'app installée sur
// l'écran d'accueil, où le cookie n'est pas toujours transmis.
export const CLE_JETON = "espace_session";

export const espaceApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/espace`,
  withCredentials: true,
});

espaceApi.interceptors.request.use((config) => {
  const jeton = localStorage.getItem(CLE_JETON);
  if (jeton) config.headers.Authorization = `Bearer ${jeton}`;
  // L'école voit combien de familles ont installé l'app sur leur écran d'accueil.
  const installee = window.matchMedia?.("(display-mode: standalone)").matches
    || window.navigator.standalone === true;
  config.headers["X-App-Mode"] = installee ? "app" : "navigateur";
  return config;
});

// FastAPI renvoie parfois un tableau d'objets pour une erreur de validation : l'afficher
// tel quel fait planter React.
export function messageErreur(e, defaut = "Une erreur est survenue. Réessaie.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ") || defaut;
  if (detail?.msg) return detail.msg;
  return e?.message || defaut;
}

// L'adresse complète d'un document signé rendu par le serveur (facture, attestation) :
// le lien porte sa propre autorisation, il s'ouvre donc aussi dans la visionneuse PDF de
// l'iPhone, là où un fichier téléchargé « en coulisse » restait bloqué.
export const urlServeur = (chemin) => `${process.env.REACT_APP_BACKEND_URL}${chemin}`;

// Secours quand aucun lien signé n'est disponible : on récupère le PDF ici puis on l'ouvre.
// Une erreur arrive alors sous forme de fichier : on la relit pour afficher la vraie phrase
// (« Aucun montant payé… ») au lieu d'un « code 400 » incompréhensible.
export async function ouvrirPdf(chemin) {
  const fenetre = window.open("", "_blank");
  try {
    const { data } = await espaceApi.get(chemin, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (fenetre) fenetre.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    fenetre?.close();
    const blob = e?.response?.data;
    if (blob instanceof Blob) {
      try { e.response.data = JSON.parse(await blob.text()); } catch { /* pas du JSON */ }
    }
    throw e;
  }
}
